
import { storageMixin } from 'mixins'

export default {
  mixins: [storageMixin],
  data() {
    return {
      mixin_isGodMode: false
    }
  },
  methods: {
    changeGoodMode(newState) {
      this.$_savePropToLocalStorage('GodMode', +newState, true)
      this.$router.go()
      this.mixin_isGodMode = newState
    },
  },
  computed: {
    /**
     * Доступ к работе с шаблонами критерий
     */
    isAccesToCriteriaTemplate() {
      return this.mixin_isGodMode || this.$acl.check('tenderAdmin')
    },
    /**
     * Доступ к тендеру
     */
    mixin_accessToTenderView() {
      return this.$can('set', 'tenderViews') || this.mixin_isGodMode
    }
  },
  created() {
    this.mixin_isGodMode = !!this.$_getPropFromLocalStorage('GodMode', false, true)
    if (this.mixin_isGodMode && !this.$acl.check('isGoodMode')) {
      this.changeGoodMode(false)
    }
  }
}
